(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qd-header"]) return;
  try {
    
  class QDHeader extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller=new AbortController();
      const signal=this.controller.signal;
      this.setAttribute('data-enhanced','');
      this.menus=[...this.querySelectorAll('[data-qd-menu]')];
      this.querySelectorAll('.qd-family').forEach(family=>family.addEventListener('toggle',()=>{
        if(family.open)family.parentElement.querySelectorAll('.qd-family').forEach(other=>{if(other!==family)other.open=false;});
        this.syncButtons();
      },{signal}));
      this.menus.forEach(menu=>menu.addEventListener('toggle',()=>{
        if(menu.open){this.menus.forEach(other=>{if(other!==menu)other.open=false;});const first=menu.querySelector('.qd-family');if(first&&!menu.querySelector('.qd-family[open]'))first.open=true;}
        this.syncButtons();
      },{signal}));
      this.querySelectorAll('[data-qd-open-family]').forEach(button=>button.addEventListener('click',()=>{
        const menu=this.querySelector('[data-qd-menu="products"]');
        const family=[...menu.querySelectorAll('.qd-family')].find(item=>item.dataset.qdFamily===button.dataset.qdOpenFamily);
        const shouldClose=menu.open&&family?.open;
        menu.open=!shouldClose;
        if(family&&!shouldClose){menu.querySelectorAll('.qd-family').forEach(item=>item.open=item===family);family.querySelector('summary').focus();}
        this.syncButtons();
      },{signal}));
      this.addEventListener('keydown',event=>{if(event.key==='Escape'){const open=this.menus.find(menu=>menu.open);if(open){open.open=false;open.querySelector('summary').focus();event.preventDefault();}}},{signal});
      document.addEventListener('pointerdown',event=>{if(!this.contains(event.target))this.menus.forEach(menu=>menu.open=false);},{signal});
      this.observer=new ResizeObserver(()=>{document.body.style.setProperty('--header-height',`${this.offsetHeight}px`);document.body.style.setProperty('--header-group-height',`${this.offsetHeight}px`);});
      this.observer.observe(this);
    }
    syncButtons(){this.querySelectorAll('[data-qd-open-family]').forEach(button=>{const menu=this.querySelector('[data-qd-menu="products"]');const family=[...menu.querySelectorAll('.qd-family')].find(item=>item.dataset.qdFamily===button.dataset.qdOpenFamily);button.setAttribute('aria-expanded',String(menu.open&&family?.open));});}
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();}
  }
  class QDSearch extends HTMLElement {
    connectedCallback(){
      this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
      this.input=this.querySelector('[data-qd-input]');this.panel=this.querySelector('[data-qd-panel]');this.results=this.querySelector('[data-qd-results]');this.status=this.querySelector('[data-qd-status]');this.clear=this.querySelector('[data-qd-clear]');this.form=this.querySelector('form');this.type=this.querySelector('[data-qd-type]');this.categories=this.querySelector('[data-qd-categories]');this.epoch=0;this.index=-1;
      this.clear.hidden=!this.input.value;
      this.input.addEventListener('focus',()=>{if(this.categories)this.categories.open=false;},{signal});
      this.categories?.addEventListener('toggle',()=>{if(this.categories.open){this.cancel();this.close();}},{signal});
      this.addEventListener('keydown',event=>{if(event.key==='Escape'&&this.categories?.open){this.categories.open=false;this.categories.querySelector('summary').focus();event.preventDefault();}},{signal});
      this.input.addEventListener('input',()=>{this.clear.hidden=!this.input.value;this.cancel();this.close();const epoch=this.epoch;this.timer=setTimeout(()=>this.search(epoch),180);},{signal});
      this.input.addEventListener('keydown',event=>this.keydown(event),{signal});
      this.type?.addEventListener('change',()=>{this.cancel();this.close();this.search(this.epoch);},{signal});
      this.clear.addEventListener('click',()=>{this.cancel();this.input.value='';this.clear.hidden=true;this.close();this.input.focus();},{signal});
      document.addEventListener('pointerdown',event=>{if(!this.contains(event.target)){this.cancel();this.close();if(this.categories)this.categories.open=false;}},{signal});
    }
    cancel(){clearTimeout(this.timer);this.request?.abort();this.epoch++;this.index=-1;}
    close(){this.panel.hidden=true;this.input.setAttribute('aria-expanded','false');this.input.removeAttribute('aria-activedescendant');this.status.textContent='';this.index=-1;}
    fullURL(){const url=new URL(this.form.action,location.origin);new FormData(this.form).forEach((value,key)=>{if(value)url.searchParams.set(key,value);});return url;}
    async search(epoch){
      const query=this.input.value.trim();if(query.length<2){this.close();return;}
      this.querySelector('[data-qd-all-results]').href=this.fullURL().href;
      if(this.type?.value){this.results.replaceChildren();const text=document.createElement('p');text.className='qd-search__notice';text.textContent=this.dataset.filtered;this.results.append(text);this.show();return;}
      this.request=new AbortController();this.status.textContent=this.dataset.loading;
      const url=new URL(this.dataset.predictiveUrl,location.origin);url.searchParams.set('q',query);url.searchParams.set('section_id','qd-predictive-search');url.searchParams.set('resources[type]','product,collection');url.searchParams.set('resources[limit]','6');url.searchParams.set('resources[limit_scope]','each');
      try{const response=await fetch(url,{signal:this.request.signal});if(!response.ok)throw new Error('search');const html=await response.text();if(epoch!==this.epoch)return;const result=new DOMParser().parseFromString(html,'text/html').querySelector('[data-qd-search-results]');if(!result){this.close();return;}this.results.replaceChildren(result);this.show();this.status.textContent=result.querySelector('[data-qd-count]')?.textContent||'';}
      catch(error){if(error.name!=='AbortError'){this.status.textContent='';this.close();}}
    }
    show(){this.panel.hidden=false;this.input.setAttribute('aria-expanded','true');this.index=-1;}
    keydown(event){
      if(event.key==='Escape'){this.cancel();this.close();return;}
      const options=[...this.results.querySelectorAll('[role="option"]')];
      if((event.key==='ArrowDown'||event.key==='ArrowUp')&&!this.panel.hidden&&options.length){event.preventDefault();this.index=this.index<0?(event.key==='ArrowDown'?0:options.length-1):(this.index+(event.key==='ArrowDown'?1:-1)+options.length)%options.length;options.forEach((option,index)=>option.setAttribute('aria-selected',String(index===this.index)));this.input.setAttribute('aria-activedescendant',options[this.index].id);options[this.index].scrollIntoView({block:'nearest'});}
      if(event.key==='Enter'&&this.index>=0&&!this.panel.hidden){event.preventDefault();location.href=options[this.index].querySelector('a').href;}
    }
    disconnectedCallback(){this.cancel();this.controller?.abort();}
  }
  if(!customElements.get('qd-header'))customElements.define('qd-header',QDHeader);
  if(!customElements.get('qd-search'))customElements.define('qd-search',QDSearch);

  } catch(e) { console.error(e); }
})();
})();
